import classNames from 'classnames'
import * as React from 'react'

import Icon from 'components/Icon'
import { UI } from 'Icon/ui'

import './ButtonExtended.scss'

interface ButtonExtendedProps {
  header: string | JSX.Element
  subHeader?: string | JSX.Element
  icon?: JSX.Element
  i?: number
  iMax?: number
  isCentred?: boolean
  isActive?: boolean
  hideChevron?: boolean
  dropdown?: boolean
  onClick?: () => void
  colored?: boolean
  type?: string
}

const ButtonExtended: React.FC<ButtonExtendedProps> = props => {
  const className = classNames(
    'srprs-buttonExtended',
    props.isCentred && 'is-centered',
    props.dropdown && 'is-dropdown',
    props.colored && 'is-colored',
    props.type && `type-${props.type}`,
  )

  return (
    <button className={className} onClick={props.onClick}>
      {props.icon ? (
        <div className="wrapper-icon">
          <Icon icon={props.icon} />
        </div>
      ) : null}

      <div className="wrapper-inner">
        {props.dropdown ? <span>{props.subHeader}</span> : null}
        <strong>{props.header}</strong>
        {!props.dropdown ? <span>{props.subHeader}</span> : null}
      </div>

      <div className="wrapper-right">
        {props.i !== undefined ? (
          <i className={props.isActive ? 'is-active' : ''}>
            {props.i}
            {props.iMax ? `/${props.iMax}` : null}
          </i>
        ) : null}
        {!props.hideChevron ? (
          <Icon icon={props.dropdown ? UI.chevronDown : UI.chevronRight} />
        ) : null}
      </div>
    </button>
  )
}

export default ButtonExtended
